import { init_gradient_table } from 'amt_admin/utils';


const season_table = () => ({
    template: require('./table.html'),
    restrict: 'E',
    scope: {
        api_method: "@apiMethod",
    },
    controller: [
        '$scope', 'rating_arena_api', 'chartFilters',
        function($scope, rating_arena_api, chartFilters) {
            $scope.vm = {};
            $scope.get_bg_color = table.get_bg_color;
            const { api_method } = $scope;
            const table = init_gradient_table();
            const set_table_data = function(resp) {
                Object.assign($scope.vm, resp);
                const rows = resp.rows.map(row => _.pick(row, ...resp.columns));
                table.set_rows(rows);
            };
            const update_table = function(model) {
                rating_arena_api[api_method](model).then(set_table_data);
            };
            update_table(chartFilters.get_chart_filters());
            chartFilters.onChangeChartParams('update_' + api_method, update_table);
        },
    ],
});

export default season_table;
